import config from "@/config";
import { requests } from ".";
export const ProductService = {
    getProducts: (params) => requests(config.PRODUCT_SERVICE_URL).get('/products/', {
        params,
    })
};
